/* CAFFREY product-page kit — behaviour (Claude Code, foundation agent 2, 2026-10-06).
   <cf-kit-buy>    variant picker → hidden [name=id] (+ bubbling change event), price, button state, ?variant= URL
   <cf-kit-sticky> bottom buy bar that mirrors and submits the page's MAIN product form
   <cf-kit-size>   highlights the selected EU size and shows its approximate US equivalent
   Safe to include more than once (defer). No dependencies; uses Dawn's pub/sub when present. */
(function () {
  if (window.CfKit) return;

  var EXCLUDE = '[data-cf-kit-quick], .cf-kit-routine, .cf-kit-which, quick-add-modal, .quick-add-modal, .card-wrapper, .product-card-wrapper, cf-kit-sticky';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function findMainForm(id) {
    if (id) {
      var byId = document.getElementById(id);
      if (byId && byId.tagName === 'FORM') return byId;
    }
    var marked = document.querySelector('form[data-cf-role="main"], form[data-cf-main-form]');
    if (marked) return marked;
    var scope = document.querySelector('main') || document;
    var forms = scope.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i];
      if (f.closest(EXCLUDE)) continue;
      if (f.querySelector('button[type="submit"], input[type="submit"], button:not([type])')) return f;
    }
    return null;
  }

  function variantId(form) {
    if (!form) return null;
    var id = null;
    try { id = new FormData(form).get('id'); } catch (e) { /* ignore */ }
    if (!id) {
      var el = form.querySelector('[name="id"]');
      if (el && el.type !== 'radio') id = el.value;
    }
    return id ? String(id) : null;
  }

  function submitButton(form) {
    if (!form) return null;
    return form.querySelector('[data-cf-atc]') ||
      form.querySelector('button[type="submit"][name="add"]') ||
      form.querySelector('button[type="submit"], input[type="submit"], button:not([type])') ||
      (form.getAttribute('id') ? document.querySelector('button[type="submit"][form="' + form.getAttribute('id') + '"]:not([data-cf-sticky-atc])') : null);
  }

  function hasPubSub() {
    return typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';
  }

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  /* ---------------- buy box ---------------- */
  class CfKitBuy extends HTMLElement {}
  CfKitBuy.prototype.connectedCallback = function () {
    if (this._init) return;
    this._init = true;
    var self = this;
    try { this.variants = JSON.parse(this.querySelector('[data-cf-buy-variants]').textContent); } catch (e) { this.variants = []; }
    this.form = document.getElementById(this.dataset.form);
    if (!this.form) return;
    this.idInput = this.form.querySelector('input[name="id"]');
    this.atc = this.form.querySelector('[data-cf-atc]');
    this.atcLabel = this.atc ? this.atc.querySelector('span') : null;
    this.price = this.querySelector('[data-cf-price]');
    this.compare = this.querySelector('[data-cf-compare]');
    this.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-cf-variant-select]')) {
        self.select(self.variants.find(function (v) { return String(v.id) === t.value; }));
      } else if (t.closest('[data-cf-option]')) {
        self.fromOptions();
      }
    });
    this.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cf-qty]');
      if (!b) return;
      var q = self.form.querySelector('[name="quantity"]');
      if (!q) return;
      q.value = Math.max(1, (parseInt(q.value, 10) || 1) + Number(b.getAttribute('data-cf-qty')));
      q.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (this.querySelector('[data-cf-option]')) this.markAvailability(this.selected());
  };
  CfKitBuy.prototype.selected = function () {
    return Array.prototype.map.call(this.querySelectorAll('[data-cf-option]'), function (fs) {
      var c = fs.querySelector('input:checked');
      return c ? c.value : null;
    });
  };
  CfKitBuy.prototype.fromOptions = function () {
    var sel = this.selected();
    this.querySelectorAll('[data-cf-option]').forEach(function (fs) {
      var c = fs.querySelector('input:checked');
      var l = fs.querySelector('[data-cf-option-label]');
      if (c && l) l.textContent = c.getAttribute('data-cf-label') || c.value;
    });
    var v = this.variants.find(function (x) {
      return x.o.every(function (val, i) { return val === sel[i]; });
    });
    this.markAvailability(sel);
    this.select(v);
  };
  CfKitBuy.prototype.markAvailability = function (sel) {
    var variants = this.variants;
    this.querySelectorAll('[data-cf-option]').forEach(function (fs, i) {
      fs.querySelectorAll('input').forEach(function (input) {
        var ok = variants.some(function (v) {
          if (!v.a || v.o[i] !== input.value) return false;
          return v.o.every(function (val, j) { return j === i || sel[j] === null || val === sel[j]; });
        });
        input.parentElement.classList.toggle('is-unavailable', !ok);
      });
    });
  };
  CfKitBuy.prototype.select = function (v) {
    if (this.idInput) {
      this.idInput.value = v ? v.id : '';
      this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (this.price && v) this.price.innerHTML = v.p;
    if (this.compare) {
      if (v && v.c) { this.compare.innerHTML = v.c; this.compare.hidden = false; } else { this.compare.hidden = true; }
    }
    if (this.atc) {
      var ok = !!(v && v.a);
      this.atc.disabled = !ok;
      if (this.atcLabel) this.atcLabel.textContent = ok ? this.dataset.add : (v ? this.dataset.soldOut : this.dataset.unavailable);
    }
    if (v && this.dataset.role === 'main' && window.history && history.replaceState) {
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', u.toString());
      } catch (e) { /* ignore */ }
    }
    this.dispatchEvent(new CustomEvent('cf-kit:variant', { bubbles: true, detail: { variant: v || null } }));
  };

  /* ---------------- sticky buy bar ---------------- */
  class CfKitSticky extends HTMLElement {}
  CfKitSticky.prototype.connectedCallback = function () {
    // position:fixed breaks inside transformed ancestors (Dawn's slide-in animation): live directly in <body>.
    if (this.parentElement !== document.body) { document.body.appendChild(this); return; }
    if (this._init) return;
    this._init = true;
    var self = this;
    try { this.variants = JSON.parse(this.querySelector('[data-cf-variants]').textContent); } catch (e) { this.variants = {}; }
    this.btn = this.querySelector('[data-cf-sticky-atc]');
    this.label = this.btn ? this.btn.querySelector('span') : null;
    this.priceEl = this.querySelector('[data-cf-sticky-price]');
    this.variantEl = this.querySelector('[data-cf-sticky-variant]');
    onReady(function () { self.start(); });
  };
  CfKitSticky.prototype.start = function () {
    var self = this;
    this.form = findMainForm(this.dataset.form);
    if (!this.form || !this.btn) { this.setAttribute('hidden', ''); return; }
    var sync = function () { self.sync(); };
    this.form.addEventListener('change', sync);
    this.form.addEventListener('input', sync);
    document.addEventListener('change', function (e) { if (e.target && e.target.form === self.form) sync(); });
    this.btn.addEventListener('click', function () { self.add(); });
    if (hasPubSub()) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(sync, 0); });
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { self.done(); });
      subscribe(PUB_SUB_EVENTS.cartError, function () { self.done(); self.reveal(); });
    }
    this.sync();
    this.retarget();
    // Scroll-driven (not IntersectionObserver): jump scrolls (anchor links, flings) must still reveal the bar.
    var queued = false;
    var check = function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; self.check(); });
    };
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check, { passive: true });
    this.mo = new MutationObserver(function () {
      if (!self.target || !self.target.isConnected) { self.retarget(); check(); }
    });
    this.mo.observe(this.form, { childList: true, subtree: true });
    check();
  };
  CfKitSticky.prototype.retarget = function () {
    var b = submitButton(this.form);
    this.target = b && b.getClientRects().length ? b : this.form;
  };
  CfKitSticky.prototype.check = function () {
    if (!this.target || !this.target.isConnected) this.retarget();
    if (!this.target) return;
    var r = this.target.getBoundingClientRect();
    this.setVisible(r.bottom < 0 && this.getClientRects().length > 0);
  };
  CfKitSticky.prototype.setVisible = function (on) {
    if (on === this._on) return;
    this._on = on;
    var self = this;
    var root = document.documentElement;
    this.classList.toggle('is-visible', on);
    if (on) {
      root.style.setProperty('--cf-kit-sticky-h', Math.round(this.offsetHeight) + 'px');
      root.classList.add('cf-kit-sticky-on');
      setTimeout(function () { self.chatGap(); self.avoidOverlays(); }, 380);
      if (!this._avoidTimer) this._avoidTimer = setInterval(function () { self.avoidOverlays(); }, 1200);
    } else {
      root.classList.remove('cf-kit-sticky-on');
      if (this._avoidTimer) { clearInterval(this._avoidTimer); this._avoidTimer = null; }
      this.style.bottom = '';
    }
  };
  CfKitSticky.prototype.chatGap = function () {
    var chat = document.querySelector('shopify-chat');
    var overlap = false;
    if (chat && chat.shadowRoot && this._on) {
      var b = chat.shadowRoot.querySelector('[part~="activator"]') || chat.shadowRoot.querySelector('button');
      if (b) {
        var r = b.getBoundingClientRect();
        var s = this.btn.getBoundingClientRect();
        overlap = r.width > 0 && r.left < s.right && r.right > s.left && r.top < s.bottom && r.bottom > s.top;
      }
    }
    if (overlap) this.classList.add('has-chat-gap');
  };
  /* Lead 2026-10-06 (Comfort Max re-review): small fixed widgets that third-party apps park at the bottom of the
     phone screen (e.g. Klaviyo's "GET 10% OFF!" teaser after the pop-up is closed with X) can sit on the sticky
     Add to cart, so taps land on the widget. If something other than this bar is on top of the button, lift the bar
     just above it. Full-screen pop-ups (taller than 160 px) are ignored: the shopper must close those first. */
  CfKitSticky.prototype.avoidOverlays = function () {
    if (!this._on || !this.btn) return;
    var prev = parseFloat(this.style.bottom) || 0;
    var b = this.btn.getBoundingClientRect();
    var pts = [[b.left + b.width / 2, b.top + b.height / 2], [b.left + 6, b.top + b.height / 2], [b.right - 6, b.top + b.height / 2]];
    var lift = 0, self = this;
    pts.forEach(function (pt) {
      var el = document.elementFromPoint(pt[0], pt[1]);
      if (!el || self.contains(el)) return;
      var n = el, cover = null;
      while (n && n !== document.body) {
        var cs = getComputedStyle(n);
        if (cs.position === 'fixed' || cs.position === 'sticky') { cover = n; break; }
        n = n.parentElement;
      }
      if (!cover || cover.tagName === 'SHOPIFY-CHAT') return;
      var r = cover.getBoundingClientRect();
      if (r.height > 0 && r.height <= 160) lift = Math.max(lift, Math.round(window.innerHeight - r.top + 8 - prev));
    });
    if (lift > 0) {
      var next = Math.min(prev + lift, 220);
      this.style.bottom = next + 'px';
      document.documentElement.style.setProperty('--cf-kit-sticky-h', Math.round(this.offsetHeight + next) + 'px');
    }
  };
  CfKitSticky.prototype.sync = function () {
    var id = variantId(this.form);
    var v = id ? this.variants[id] : null;
    if (v) {
      if (this.priceEl) this.priceEl.innerHTML = v.p;
      if (this.variantEl) this.variantEl.textContent = (this.dataset.prefix || '') + v.t;
    }
    var ok = !!(v && v.a);
    this.btn.disabled = !ok;
    if (this.label) this.label.textContent = ok ? this.dataset.add : (v ? this.dataset.soldOut : this.dataset.unavailable);
  };
  CfKitSticky.prototype.add = function () {
    if (this.btn.disabled) return;
    var self = this;
    var main = submitButton(this.form);
    this.btn.classList.add('loading');
    this.btn.setAttribute('aria-busy', 'true');
    clearTimeout(this._t);
    var dawn = !!this.form.closest('product-form');
    this._t = setTimeout(function () { self.done(); }, dawn ? 4000 : 1200);
    if (main && !main.disabled && main.getAttribute('aria-disabled') !== 'true') main.click();
    else if (this.form.requestSubmit) this.form.requestSubmit();
    else this.form.submit();
  };
  CfKitSticky.prototype.done = function () {
    clearTimeout(this._t);
    this.btn.classList.remove('loading');
    this.btn.removeAttribute('aria-busy');
  };
  CfKitSticky.prototype.reveal = function () {
    var t = submitButton(this.form) || this.form;
    t.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
  };

  /* ---------------- size help ---------------- */
  class CfKitSize extends HTMLElement {}
  CfKitSize.prototype.connectedCallback = function () {
    if (this._init) return;
    this._init = true;
    var self = this;
    try { this.map = JSON.parse(this.querySelector('[data-cf-size-map]').textContent); } catch (e) { this.map = {}; }
    this.cur = this.querySelector('[data-cf-size-current]');
    onReady(function () {
      self.form = findMainForm(self.dataset.form);
      if (!self.form) return;
      var sync = function () { self.sync(); };
      self.form.addEventListener('change', sync);
      document.addEventListener('change', function (e) { if (e.target && e.target.form === self.form) sync(); });
      if (hasPubSub()) subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(sync, 0); });
      self.sync();
    });
  };
  CfKitSize.prototype.sync = function () {
    var id = variantId(this.form);
    var val = id ? this.map[id] : null;
    var row = null;
    this.querySelectorAll('tr[data-cf-size-value]').forEach(function (tr) {
      var on = val != null && tr.getAttribute('data-cf-size-value') === val;
      tr.classList.toggle('is-current', on);
      if (on) row = tr;
    });
    if (this.cur) {
      var m = row ? row.getAttribute('data-m') : '';
      this.cur.textContent = row && m && m !== '—'
        ? this.dataset.tpl.replace('[m]', m).replace('[w]', row.getAttribute('data-w'))
        : '';
    }
  };

  [['cf-kit-buy', CfKitBuy], ['cf-kit-sticky', CfKitSticky], ['cf-kit-size', CfKitSize]].forEach(function (d) {
    if (!customElements.get(d[0])) customElements.define(d[0], d[1]);
  });

  // VISUAL-AURA audit (2026-10-07, Claude Code, visual-aura implementer): Klaviyo's bottom teaser bar must not cover the
  // product page's price row. Nothing of Klaviyo is hidden or moved: the height of any short Klaviyo bar fixed to the bottom of
  // the viewport is published as --cf-bottom-overlay on <html> (class cf-kit-overlay-on); the product heroes subtract it from
  // their first-screen stage and the chat bubble rides above it (cf-kit.css). The full-screen pop-up itself is ignored.
  (function guardBottomOverlays() {
    if (!document.body || !window.MutationObserver) return;
    var root = document.documentElement, last = -1, timer = null;
    function fixedBars(el, out) {
      var cs = getComputedStyle(el);
      if (cs.position === 'fixed') out.push(el);
      else for (var i = 0; i < el.children.length && i < 40; i++) fixedBars(el.children[i], out);
    }
    function scan() {
      var vh = window.innerHeight, h = 0, cands = [];
      var roots = document.querySelectorAll('[class*="kl-private-reset-css"], [class*="kl-teaser"], .klaviyo-form, [data-testid="animated-teaser"]');
      for (var i = 0; i < roots.length && i < 30; i++) fixedBars(roots[i], cands);
      for (var j = 0; j < cands.length; j++) {
        var el = cands[j], cs = getComputedStyle(el);
        if (cs.display === 'none' || cs.visibility === 'hidden' || Number(cs.opacity) < 0.05) continue;
        var r = el.getBoundingClientRect();
        if (r.height < 16 || r.height > 140 || r.bottom < vh - 30 || r.top >= vh) continue;
        h = Math.max(h, Math.ceil(vh - r.top));
      }
      if (h !== last) {
        last = h;
        root.style.setProperty('--cf-bottom-overlay', h + 'px');
        root.classList.toggle('cf-kit-overlay-on', h > 0);
      }
    }
    function soon() { if (!timer) timer = setTimeout(function () { timer = null; scan(); }, 150); }
    new MutationObserver(soon).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
    window.addEventListener('resize', soon, { passive: true });
    scan();
  })();

  window.CfKit = { findMainForm: findMainForm, variantId: variantId, submitButton: submitButton };
})();
